import { useTranslation } from 'react-i18next'

import { LandingDemoPlayer } from '@/features/demos/LandingDemoPlayer'

import { EscandalloDemoCard } from './EscandalloDemoCard'

export function SeoKeywordDemoSection() {
    const { t } = useTranslation()

    return (
        <section className='bg-[#F5EEE4] px-[22px] py-12 md:px-10 md:py-16'>
            <div className='mx-auto flex w-full max-w-[720px] flex-col gap-8 md:max-w-[900px]'>
                <div className='flex flex-col md:grid md:grid-cols-[minmax(0,0.95fr)_minmax(280px,1.05fr)] md:items-center md:gap-10'>
                    <div className='mb-5 flex flex-col gap-2.5 md:mb-0'>
                        <div className='text-xs font-semibold uppercase tracking-[2px] text-[#F4502A]'>
                            {t('seoKeyword.shared.demo.eyebrow', 'Un escandallo real')}
                        </div>
                        <h2 className='m-0 text-pretty text-[28px] font-medium leading-[1.15] tracking-[-1px] text-[#17130E] md:text-[36px]'>
                            {t('seoKeyword.shared.demo.title', 'Así queda el escandallo de un plato')}
                        </h2>
                        <p className='m-0 text-[15px] leading-[1.6] text-[#5C5548] md:text-base'>
                            {t(
                                'seoKeyword.shared.demo.subtitle',
                                'Dictas los ingredientes y las cantidades. Tipi calcula el resto.',
                            )}
                        </p>
                    </div>
                    <LandingDemoPlayer demoId='escandallo-voz' />
                </div>
                <EscandalloDemoCard />
            </div>
        </section>
    )
}
